import { I18nNamespace } from '@/lib/i18n-namespaces';
import { WarningIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../Badge';

export function ErrorBadge() {
    const { t } = useTranslation(I18nNamespace.SOURCES);
    return (
        <Badge variant="error">
            <WarningIcon size={16} weight="fill" />
            <span className="text-xs-medium">{t('status.error')}</span>
        </Badge>
    );
}
